<template>
  <v-col :cols="cols">
    <v-hover close-delay="200">
      <div slot-scope="{ hover }">
        <v-container class="pa-0">
          <v-card color="color-2" height="200px">
            <v-card-text class="text-center">
              <h2>{{name}}</h2>
              <v-icon class="mt-5" size="100">{{icon}}</v-icon>
            </v-card-text>
              <v-layout class="ma-3" align-center justify-center>
                <v-progress-circular v-if="loading" :size="100" width="6"  indeterminate/>
              </v-layout>
          </v-card>
          <v-card v-for="(nav, index) in navigation_list" :key="index"
                  v-show="hover"
                  :class="`${hover? 'cursor-pointer' : ''}`"
                  class="mt-5 pa-2"
                  color="color-2"
                  @click="route(nav.to)"
                  >
            <h2>{{nav.text}}</h2>
          </v-card>
        </v-container>
      </div>
    </v-hover>
  </v-col>
</template>
<script>
export default {
  props: ['navigation_list', 'icon', 'name', 'loading', 'cols'],
  data: () => ({
  }),
  methods: {
    route(to){
      this.$router.push(to);
    }
  }
}
</script>
<style lang="scss" scoped>
.shadow {
  text-shadow: 1px 1px #000;
}
</style>
